import React, { FC, useEffect, useMemo, useState } from "react"

import { Button, Descriptions, Modal } from "antd"
import TextArea from "antd/es/input/TextArea"

import { callStatus } from "../../../constants/statuses"
import { useActions } from "../../../hooks/useActions"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { showErrorNotification } from "../../../utils/ui"
import MetroView from "../../ui/metro-view/MetroView"

import "./CallWrapper.scss"

const CallWrapper: FC = ({ children }) => {
    const openSound = useMemo(() => new Audio("/assets/ring.mp3"), []) 

    const [ callModalOpen, setCallModalOpen ] = useState(false)
    const [ callLoading, setCallLoading ] = useState(false)

    const { currentCall } = useTypedSelector((state) => state.currentUser)
    const { currentUserSetCall, currentUserSendCallStatus } = useActions()

    const [ note, setNote ] = useState(currentCall?.notes || "")

    useEffect(() => {
        if (currentCall?.id && !callModalOpen) {
            setCallModalOpen(true)
            openSound.play()
        }
    }, [ currentCall ])

    const sendStatus = (status: number) => {
        if (currentCall && status) {
            setCallLoading(true)

            currentUserSendCallStatus(currentCall.id, status, note, () => {
                currentUserSetCall(null)
                setCallModalOpen(false)
                setCallLoading(false)
            }, () => {
                showErrorNotification("Ошибка при отправке статуса объявления, повторите попытку")
                setCallLoading(false)
            })
        }
    }

    return (
        <>
            {children}

            <Modal
                title="Текущий вызов"
                open={callModalOpen}
                onCancel={() => setCallModalOpen(false)}
                width={700}
                className="call-modal"
                footer={
                    <div className="call-modal-footer">
                        <Button
                            className="call-btn call-btn-success"
                            disabled={callLoading}
                            onClick={() => sendStatus(callStatus.our_flat)}
                        >
                            Квартира наша
                        </Button>
                        <Button
                            className="call-btn call-btn-danger"
                            disabled={callLoading}
                            onClick={() => sendStatus(callStatus.not_our)}
                        >
                            Не снял
                        </Button>
                        <Button
                            className="call-btn call-btn-info"
                            disabled={callLoading}
                            onClick={() => sendStatus(callStatus.agent)}
                        >
                            Агент
                        </Button>
                        <Button
                            className="call-btn call-btn-warning"
                            disabled={callLoading}
                            onClick={() => sendStatus(callStatus.not_callable)}
                        >
                            Не дозвонился
                        </Button>
                        <Button
                            className="call-btn call-btn-danger"
                            disabled={callLoading}
                            onClick={() => sendStatus(callStatus.not_first)}
                        >
                            Не первые
                        </Button>
                    </div>
                }
                closable={false}
                maskClosable={false}
            >
                <div className="call-modal-content">
                    <Descriptions
                        layout="horizontal"
                        column={1}
                        size="small"
                    >
                        <Descriptions.Item label="Объявление">
                            <span dangerouslySetInnerHTML={{ __html: currentCall?.title || "" }} />
                        </Descriptions.Item>
                        <Descriptions.Item label="Адрес">
                            {currentCall?.address}
                        </Descriptions.Item>
                        <Descriptions.Item label="Метро">
                            <MetroView
                                title={currentCall?.metro?.name}
                                color={`#${currentCall?.metro?.color}`}
                            />
                        </Descriptions.Item>
                        <Descriptions.Item label="Стоимость">
                            <span className="price-value">{currentCall?.price}</span>
                        </Descriptions.Item>
                        <Descriptions.Item label={currentCall?.source === 4 ? "Источник" : "Телефон"}>
                            {currentCall?.source === 4 ? (
                                <span className="phone-value">Звонок через Юлу</span>
                            ) : (
                                <span className="phone-value">{currentCall?.phone}</span>
                            )}
                        </Descriptions.Item>
                    </Descriptions>

                    <div className="note-section">
                        <label className="note-label">Заметка:</label>
                        <TextArea
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            placeholder="Добавьте заметку..."
                            rows={3}
                        />
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default CallWrapper